import { PopupWrapper, PopupTitleWrapper, PopupCodeBox } from "../referralPageStyling";
import GlobalPopupContainerCenter from "../../../components/globalPopup/GlobalPopupContainerCenter";
import useClickOutside from "../../../hook/useClickOutside";
import { useToast } from "../../../components/toast/ToastContext";

interface GetYourCodePopupProps {
    getCodePopup: boolean;
    handleClosePopup: () => void;
}

export default function GetYourCodePopup({ getCodePopup, handleClosePopup }: GetYourCodePopupProps) {
    const referralCode = "AU10OFF";
    const { showToast } = useToast();
    const getCodePopupRef = useClickOutside(getCodePopup, handleClosePopup);

    const handleCopyCode = async () => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(referralCode);
                showToast("Copied to clipboard", "success");
            } else {
                // Fallback for non-secure contexts
                const textArea = document.createElement("textarea");
                textArea.value = referralCode;
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    showToast("Copied to clipboard", "success");
                } catch (err) {
                    showToast("Failed to copy code", "error");
                }
                textArea.remove();
            }
        } catch (err) {
            showToast("Failed to copy code", "error");
        }
    };

    return (
        <GlobalPopupContainerCenter
            ref={getCodePopupRef}
            backBtnType="Close"
            closePopup={handleClosePopup}
            btnText="Copy"
            handleSave={handleCopyCode}
        >
            <PopupWrapper>
                <PopupTitleWrapper>
                    <PopupCodeBox onClick={handleCopyCode}>{referralCode}</PopupCodeBox>
                </PopupTitleWrapper>
            </PopupWrapper>
        </GlobalPopupContainerCenter>
    );
}
